import PropTypes from "prop-types";
import "../assets/css/components.css";

export const Preview = ({ type = "", currentList = [], newList = [] }) => {
  const renderList = (list, label) => (
    <div className="white-container">
      <label>{label}</label>
      <hr />
      {list.map((url, index) =>
        type === "image" ? (
          <img
            key={index}
            src={url}
            alt={`Selected ${index}`}
            className="image-preview"
          />
        ) : type === "video" ? (
          <video src={url} key={index} controls className="video-preview" />
        ) : (
          <div key={index}></div>
        )
      )}
    </div>
  );

  return (
    <div>
      {newList.length > 0 && renderList(newList, "New Uploaded")}
      {currentList.length > 0 && renderList(currentList, "Uploaded")}
    </div>
  );
};

Preview.propTypes = {
  currentList: PropTypes.array,
  newList: PropTypes.array,
  type: PropTypes.string,
};
